import { initClientSide } from '$lib/sentry';
import { handleErrorWithSentry } from '@sentry/sveltekit';

initClientSide();

export const handleError = (error, request) => {
	handleErrorWithSentry(error, request);
};
